import React from "react";
import { useEffect, useState } from "react";
import axios from 'axios';

function MenuInventario () {

  const [dataMenu, setDataMenu] = useState(getDataMenu());

  async function getDataMenu () {
    console.log('entra en MenuInventario->getDataMenu')
    //const datos = [{"uno":"1", "dos":"2"}, {"uno":"3", "dos":"4"}];
    let datos = [];
    await axios({
      method: "POST",
      url:"/api/menuinventario",
    })
    .then((response) => {
      console.log('axios getDataMenu: ', response.data.datos[0]);
      //setDatos(response.data.datos);
      datos = response.data.datos;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response)
        console.log(error.response.status)
        console.log(error.response.headers)
        }
    });

    return datos;
  }

  return {
    dataMenu
  };
};

export default MenuInventario;